import Typography from '@/ui/components/typography'
import { Container, MoreUsers } from './RelatedUsers.styles'

interface RelatedUsersProps {
    emails: string[]
    maxDisplay?: number
}

const RelatedUsers = ({ emails, maxDisplay = 3 }: RelatedUsersProps) => {
    const actualMaxDisplay =
        emails.length > maxDisplay ? maxDisplay - 1 : maxDisplay
    const displayedEmails = emails.slice(0, actualMaxDisplay)
    const remainingCount = emails.length - actualMaxDisplay

    return (
        <Container>
            {displayedEmails.map((email, index) => (
                <Typography
                    className="table-cell-text"
                    testId={'fd-table-recipients-email'}
                    variant="xs-regular"
                    key={`${email}-${index}`}
                >
                    {email}
                </Typography>
            ))}
            {remainingCount > 0 && (
                <MoreUsers
                    className="table-cell-text"
                    data-testid={'fd-table-more-users'}
                >
                    +{remainingCount} more users
                </MoreUsers>
            )}
        </Container>
    )
}

export default RelatedUsers
